export default __webpack_public_path__ + "static/media/icon-qrcode.79cff0db.svg";